import { Action, ActionType, ContextState } from './types'

/**
 * Approval context provider reducer.
 * @param {State} state
 * @param {Action} action
 * @returns {State}
 */
export function reducer(state: ContextState, action: Action): ContextState {
  switch (action.type) {
    case ActionType.setCommentDialogOpen: {
      return {
        ...state,
        commentDialogOpen: action.payload,
      }
    }
    case ActionType.setComments: {
      return {
        ...state,
        comments: action.payload,
      }
    }
    case ActionType.setCurrentCommentDetails: {
      return {
        ...state,
        currentCommentDetails: action.payload,
      }
    }
    case ActionType.setRowsWithComments: {
      return {
        ...state,
        rowsWithComments: action.payload,
      }
    }
    case ActionType.clearComments: {
      return {
        ...state,
        currentCommentDetails: null,
        rowsWithComments: [],
        comments: {},
      }
    }
    default:
      return state
  }
}
